import { render } from "./bidangPerencanaan.vue?vue&type=template&id=d9176630"
import script from "./bidangPerencanaan.vue?vue&type=script&lang=js"
export * from "./bidangPerencanaan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__